export default __webpack_public_path__ + "static/media/select-all.6881fe11.svg";